import { render, staticRenderFns } from "./appendix-credits.vue?vue&type=template&id=3a1cac1e&scoped=true"
import script from "./appendix-credits.vue?vue&type=script&lang=js"
export * from "./appendix-credits.vue?vue&type=script&lang=js"
import style0 from "./appendix-credits.vue?vue&type=style&index=0&id=3a1cac1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1cac1e",
  null
  
)

export default component.exports